module.exports = "pegasus_template/assets/square-pinterest.gif";